import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import VeeValidate from "vee-validate";
import router from "./router";
Vue.config.productionTip = false;

import Common from "./Common";

import _ from "lodash";
import Paginate from "vuejs-paginate";
Vue.component("Paginate", Paginate);

import Loading from "./components/common/Loading";
import Modal from "./components/common/Modal";

Vue.component("loading", Loading);
Vue.component("modal", Modal);

import "@/assets/css/bootstrap-theme.min.css";
import "@/assets/css/ngToast.min.css";
import "@/assets/css/print.css";
import "@/assets/css/style.css";
import "@/assets/css/bootstrap.min.css";
import "@/assets/content/css/site.css";
import "@/assets/content/css/socialbuttons.css";
import "@/assets/content/css/fontawesome.min.css";
//import "@/assets/content/css/Pagination.css";
//import "@/assets/fonts/Sanchez_Italic.ttf";
import "@/assets/fonts/RobotoSlab_Regular.ttf";

import "url-search-params-polyfill";
const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

// Vue.extend({
//   mixins: [Common]
// });

Object.defineProperty(Vue.prototype, "_", {
  value: _
});

Vue.directive("currentdate", {
  bind: function (el, binding, vnode) {
    let date = new Date();
    var hrs = date.getHours();
    var ampm = hrs >= 12 ? "PM" : "AM";
    var mns = date.getMinutes();
    mns = mns < 10 ? "0" + mns : mns;
    hrs = hrs % 12;
    let formatted_date =
      date.getDate() +
      "-" +
      months[date.getMonth()] +
      "-" +
      date.getFullYear() +
      " " +
      hrs +
      ":" +
      mns +
      " " +
      ampm;
    el.innerHTML = formatted_date;
  }
});

import "vue-date-pick/dist/vueDatePick.css";

Vue.use(VeeValidate);

VeeValidate.Validator.extend("strong_password", {
  getMessage: field =>
    `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character (E.g. , . _ & ? etc)`,
  validate: value => {
    // var strongRegex = new RegExp(
    //   //"^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    //   "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=])(?=.{8,})"
    // );
    var valid = false;
    if (value) {
      var specials = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-=";
      var _list = value.split("");
      var valid = false;
      var digit = 0;
      var lowercase = 0;
      var uppercase = 0;
      var specialCharacter = 0;

      for (var i = 0; i < _list.length; i++) {
        var character = _list[i];
        if (_list[i] == "") {
          valid = false;
          break;
        }
        if (!isNaN(character * 1)) {
          digit++;
          continue;
        } else {
          var index = character.indexOf();
          if (specials.indexOf(character) >= 0) {
            specialCharacter++;
            continue;
          } else {
            if (character == character.toUpperCase()) {
              uppercase++;
              continue;
            }
            if (character == character.toLowerCase()) {
              lowercase++;
              continue;
            }
          }
        }
      }

      if (digit < 1 || specialCharacter < 1 || uppercase < 1 || lowercase < 1) {
        valid = false;
      } else {
        valid = true;
      }
    }
    return valid;
  }
});

VeeValidate.Validator.extend("Alpha_number_under", {
  getMessage: field =>
    "The User Name field may only contain Letters,Underscore and Numbers.",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    var re = /^\w+$/;
    if (!re.test(value)) {
      return false;
    }
    return true;
  }
});

VeeValidate.Validator.extend("Address", {
  getMessage: field =>
    "The Address field may only contain Letters,Comma and Numbers.",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    var re = /^[a-z A-Z0-9\\,.]+$/;
    if (!re.test(value)) {
      return false;
    }
    return true;
  }
});

VeeValidate.Validator.extend("Reference", {
  getMessage: field =>
    "The Your Reference field may only contain Letters, slash,numbers and dash",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    var re = /^[a-z A-Z0-9\\/-]+$/;
    if (!re.test(value)) {
      return false;
    }
    return true;
  }
});

VeeValidate.Validator.extend("Alpha_Space_Number", {
  getMessage: field => "The  field may only contain Letters,Space and Numbers.",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    var re = /^[a-z A-Z0-9]+$/;
    if (!re.test(value)) {
      return false;
    }
    return true;
  }
});

VeeValidate.Validator.extend("Phone_number_valid", {
  getMessage: field =>
    "Phone Number not a valid Number valid Number like +(xxx) xxx xxxxxxx,xxxxxxxxxxx,xxx-xxxx-xxxx",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    if (
      /^(\+?\(([0-9]{1,3})\)|\+?([0-9]{2,3}))[-. ]?([0-9]{3,10})[-. ]?([0-9]{0,4})$/.test(
        value
      )
    ) {
      return true;
    }
    return false;
  }
});
VeeValidate.Validator.extend("alpha_space_slash", {
  getMessage: field =>
    "The Unit field may contain only alphabets,space and  slash",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    if (/^[a-z A-Z/]+$/.test(value)) {
      return true;
    }
    return false;
  }
});

VeeValidate.Validator.extend("csv_error", {
  getMessage: field =>
    "The " + field + " field should not be start with @,=,+,-",
  validate: value => {
    if (!value || value == "") {
      return false;
    }
    var invalidChars = ["@", "=", "-", "+"];
    if (invalidChars.includes(value.charAt(0))) {
      return false;
    }
    return true;
  }
});
VeeValidate.Validator.extend("valid_FirstChar", {
  getMessage: () => "First character shuold not be '@','-',+','='",
  validate: (value) => {
    if (!value || value == "") {
      return false;
    }
    var re = value.charAt(0);
    if (re == "@" || re == "+" || re == "-" || re == "=") {
      return false;
    }
    return true;
  },
});

Vue.mixin(Common);
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");